export const GIS_RESOURCE_TYPES = [
  "region boundary",
  "district boundary",
  "energy",
];
